import React, { useState } from "react";
import { translate } from "react-i18next";

import { Box, Text } from "src/components";
import ChannelSelection from "src/banking/authentication/ChannelSelection";
import { useChannelSelection } from "src/banking/authentication/ForgotFlow/hooks";

const ChannelSelectionInstructions = translate("translations")(
  ({ channelSelectionDescription, t }) => (
    <Box mb={1}>
      <Text fontWeight="semibold" fontSize={4}>
        {t(channelSelectionDescription, {
          defaultValue: "Select contact preference",
        })}
      </Text>
    </Box>
  )
);

const ChannelSelectionWrapper = ({
  handleCurrentState,
  channelSelectionDescription,
  ...props
}) => {
  const { sending, onSelectChannel } = useChannelSelection(
    handleCurrentState,
    props
  );

  return (
    <ChannelSelection
      availableChannels={props.forgotFlowState.availableChannels}
      sending={sending}
      onSelectChannel={onSelectChannel}
      renderAboveChannelSelection={props => (
        <ChannelSelectionInstructions
          {...props}
          channelSelectionDescription={channelSelectionDescription}
        />
      )}
    />
  );
};

export default ChannelSelectionWrapper;



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ChannelSelection.js